import _ from 'lodash';

import { AdInventoryId } from 'src/gql/graphql';
import type { AdSettings } from 'src/gql/graphql';
import { Product } from 'src/utils/helpers/product';
import { Category } from 'src/generics/data/generic-category/data.types';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useUI from 'src/hooks/use-ui';

export const ADS_FETCH_POLICY = 'cache-and-network';
export function getMostCommonBrandSlug(products: Product[]): string {
  const result = products.reduce(
    (acc, product) => {
      const brandName = product.brandName ?? product.brand.name;

      if (brandName) {
        acc.counts[brandName] = (acc.counts[brandName] || 0) + 1;

        if (acc.counts[brandName] > acc.maxCount) {
          acc.maxCount = acc.counts[brandName];
          acc.mostCommonBrandName = brandName;
        }
      }
      return acc;
    },
    { counts: {}, maxCount: 0, mostCommonBrandName: '' }
  );

  return _.kebabCase(result.mostCommonBrandName);
}
export function useAdInventoryId(dispensaryId: string, category?: Category | null): AdInventoryId {
  const { categoryCarouselAuc, homeCarouselAuc } = AdInventoryId;

  if (category) {
    return categoryCarouselAuc;
  }

  return homeCarouselAuc;
}

export function participatingInAds(showAdByMenuVariant: boolean): boolean {
  return showAdByMenuVariant;
}

export function useParticipatingInAds(): boolean {
  const showAdByMenuVariant = useIsDispensaryMenuVariantEnabledForAds();

  return participatingInAds(showAdByMenuVariant);
}

export function useIsDispensaryMenuVariantEnabledForAds(): boolean {
  const { dispensary } = useDispensary();
  const { variant } = useUI();

  return getDispensaryMenuVariantEnabledForAds(variant, dispensary?.adSettings);
}

export function getDispensaryMenuVariantEnabledForAds(variant: string, adSettings?: AdSettings): boolean {
  const adSettingsMenuVariantMap = {
    default: 'enableAdsForDefault',
    embedded: 'enableAdsForEmbedded',
    kiosk: 'enableAdsForKiosk',
    'store-front': 'enableAdsForStoreFront',
  };

  const currentMenu = adSettingsMenuVariantMap[variant];

  return adSettings?.[currentMenu] ?? false;
}
